'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./EmptyInboxPlaceholder.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyInboxPlaceholder = function EmptyInboxPlaceholder(props) {
    return _react2.default.createElement(
        'div',
        { className: 'EmptyInboxPlaceholder' },
        _react2.default.createElement(
            'div',
            { className: 'inbox-placeholder-content' },
            _react2.default.createElement(
                'div',
                { className: 'inbox-icon' },
                _react2.default.createElement(_Icon2.default, { name: 'inbox-empty' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'inbox-description' },
                'A place to put things while you decide where they should go'
            )
        )
    );
};

EmptyInboxPlaceholder.propTypes = {
    isHovered: _propTypes2.default.bool
};

exports.default = EmptyInboxPlaceholder;


//////////////////
// WEBPACK FOOTER
// ./src/client/inbox/EmptyInboxPlaceholder.js
// module id = 2026
// module chunks = 0